import { HealthTeam } from "@/@types/esus/HealthTeam";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { Vaccination } from "@/@types/esus/Vaccination";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type DetailedCitizensVaccinationsIndicatorC2Params = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	isEvaluated?: boolean;
	ine?: string;
	export?: boolean;
};

export type VaccineStatusIndicatorC2 = "finished" | "pending" | "awaiting" | "lost";

export class DetailedCitizenVaccinationsIndicatorC2Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	healthUnitId: number = 0;
	healthTeamId: number = 0;
	healthUnit?: HealthUnit;
	healthTeam?: HealthTeam;
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	vaccinationStatus: "finished" | "pending" | "lost" = "lost";
	vaccinationResume: {
		penta: number;
		pentaStatus: VaccineStatusIndicatorC2;
		vip: number;
		vipStatus: VaccineStatusIndicatorC2;
		pneumococica: number;
		pneumococicaStatus: VaccineStatusIndicatorC2;
		tripleViral: number;
		tripleViralStatus: VaccineStatusIndicatorC2;
		refPenta: number;
		refPentaStatus: VaccineStatusIndicatorC2;
		refVip: number;
		refVipStatus: VaccineStatusIndicatorC2;
		refPneumococica: number;
		refPneumococicaStatus: VaccineStatusIndicatorC2;
		isFinished: boolean;
	} = {
		penta: 0,
		pentaStatus: "lost",
		vip: 0,
		vipStatus: "lost",
		pneumococica: 0,
		pneumococicaStatus: "lost",
		tripleViral: 0,
		tripleViralStatus: "lost",
		refPenta: 0,
		refPentaStatus: "lost",
		refVip: 0,
		refVipStatus: "lost",
		refPneumococica: 0,
		refPneumococicaStatus: "lost",
		isFinished: false,
	};
	vaccines?: Vaccination[];
}

export async function getDetailedCitizensVaccinationsIndicatorC2({
	uf,
	ibgeCode,
	...params
}: DetailedCitizensVaccinationsIndicatorC2Params) {
	const response = await esusApi.get<Paginated<DetailedCitizenVaccinationsIndicatorC2Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c2/detailed-citizens-vaccinations`,
		params
	);
	return response.data ?? new Paginated<DetailedCitizenVaccinationsIndicatorC2Data>();
}
